import { SheetPreset } from '@shared/types/list-size-preset';

export const MM_TO_PX = 3.7795275591;

export const MAX_CATALOG_ITEMS_PER_PAGE = 10000;

export const sheetPresets: SheetPreset[] = [
  { name: 'A4', widthMm: 210, heightMm: 297 },
  { name: 'A3', widthMm: 297, heightMm: 420 },
  { name: 'A5', widthMm: 148, heightMm: 210 },
  { name: 'B4', widthMm: 257, heightMm: 364 },
  { name: 'B5', widthMm: 176, heightMm: 250 },
  { name: 'Letter', widthMm: 215.9, heightMm: 279.4 },
];
